export var AccrualPeriodType;
(function (AccrualPeriodType) {
    AccrualPeriodType["Monthly"] = "Monthly";
    AccrualPeriodType["Quarterly"] = "Quarterly";
    AccrualPeriodType["EverySixMonths"] = "EverySixMonths";
    AccrualPeriodType["Annually"] = "Annually";
})(AccrualPeriodType || (AccrualPeriodType = {}));
export var EmissionType;
(function (EmissionType) {
    EmissionType["Thanks"] = "Thanks";
    EmissionType["Benefit"] = "Benefit";
    EmissionType["SupervisorBalance"] = "SupervisorBalance";
})(EmissionType || (EmissionType = {}));
export var EmissionStatus;
(function (EmissionStatus) {
    EmissionStatus["Active"] = "Active";
    EmissionStatus["Archived"] = "Archived";
})(EmissionStatus || (EmissionStatus = {}));
export var EmissionWalletActionType;
(function (EmissionWalletActionType) {
    EmissionWalletActionType["BurnBenefitBalance"] = "BurnBenefitBalance";
    EmissionWalletActionType["BurnSupervisorBalance"] = "BurnSupervisorBalance";
    EmissionWalletActionType["BurnThankBalance"] = "BurnThankBalance";
})(EmissionWalletActionType || (EmissionWalletActionType = {}));
